<template>
  <v-app>
    <Menu v-if="route.path !== '/login'" />
    <v-main>
      <div style="padding: 12px;">
        <RouterView />
        <error-dialog
          v-if="fetchError"
          :error="fetchError"
          @onDialogCancelOrConfirm="onHandleErrorDialogCancelOrConfirm"
        />
        <error-item-dialog
          v-if="itemResults"
          :response="itemResults"
          @onDialogCancelOrConfirm="onHandleErrorItemDialogCancelOrConfirm"
        />
        <info-snackbar
          ref="snackbarRef"
          :text-array="snackbarText"
          :status="snackbarStatus"
        />
      </div>
    </v-main>

    <v-snackbar
      v-model="isVisible"
      :color="currentStatus"
      location="bottom right"
    >
      <div
        v-for="text in currentTextArray"
        :key="text"
      >
        {{ text }}
      </div>
    </v-snackbar>
  </v-app>
</template>

<script setup lang="ts">

import '@/assets/css/global/google_fonts/roboto.css'
import '@/assets/css/global/materialdesign/icons/materialdesignicons.min.css'

import { onMounted, ref } from "vue";

import { useRoute } from 'vue-router';

import { useAuth } from "@/composables/useAuth";
import { useSnackbar } from "@/composables";
import { useGlobalSnackbar } from '@/composables/useGlobalSnackbar';
import { useGlobalError } from '@/composables/useGlobalError';

import Menu from "@/components/Menu.vue";
import { ErrorDialog, ErrorItemDialog } from "@/components/dialogs";
import { InfoSnackbar } from "@/components/children";

const { isVisible, currentStatus, currentTextArray } = useGlobalSnackbar();
const { fetchError, itemResults, clearFetchError, clearItemResults } = useGlobalError();

const snackbarRef = ref<InstanceType<typeof InfoSnackbar>>();
const { snackbarStatus, snackbarText } = useSnackbar(snackbarRef);

const auth = useAuth();
const route = useRoute();

const onHandleErrorDialogCancelOrConfirm = () => {
  clearFetchError();
};

const onHandleErrorItemDialogCancelOrConfirm = () => {
  clearItemResults();
};

onMounted(() => {
  auth.restoreFromStorage();
});

</script>

<style src="./assets/css/global/base.css"></style>
<style src="./assets/css/global/vuetify.css"></style>
